import Vue from 'vue';
import SvgIcon from 'vue-svgicon';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import './assets/icons';
import WeatherAPI from './api/weather';

Vue.config.productionTip = false;

Vue.use(SvgIcon, {
    tagName: 'svgicon',
});

new Vue({
    router,
    render: h => h(App),
    data() {
        return {
            units: 'metric',
            lang: 'en',
            weatherService: new WeatherAPI({
                params: {
                    lang: 'en',
                },
            }),
        };
    },
    methods: {
        getColorForIcon(iconName) {
            const colors = new Map([
                ['clear-day', '#FFD700'],
                ['clear-night', '#333333'],
                ['cloudy', '#555555'],
                ['fog', '#999999'],
                ['hail', '#00449E'],
                ['partly-cloudy-day', '#96CCFF'],
                ['partly-cloudy-night', '#AAAAAA'],
                ['rain', '#357EDD'],
                ['sleet', '#357EDD'],
                ['snow', '#CDECFF'],
                ['thunderstorm', '#5E2CA5'],
                ['tornado', '#001B44'],
            ]);
            if (colors.has(iconName)) {
                return colors.get(iconName);
            }
            return '#000';
        },
    },
}).$mount('#app');
